import React, { useMemo } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Layout, Row, Col, Card } from 'antd';
import ProposalForm from '../proposal_form/ProposalForm';
import { nullSafeGet } from '../../utils/DataAccessUtils';

const { Content } = Layout;

const BuyerNewWorkOrderProposalPage: React.FC<any> = ({ match, history }): React.ReactElement => {
	const workOrderId = useMemo(() => nullSafeGet('params.id', match), []);

	return (
		<Content>
			{/*<ScrollToTopOnMount/>*/}
			{/*<BackTop/>*/}
			<Row style={{ margin: '0.5em -8px' }} gutter={16}>
				<Col span={24}>
					<Card>
						<div>
							<ProposalForm
								formData={{
									workOrderId,
								}}
								onSuccess={history.goBack}
							/>
						</div>
					</Card>
				</Col>
			</Row>
		</Content>
	);
};

const mapStateToProps = (state, ownProps) => ({
	history: ownProps.history,
});

const mapDispatchToProps = (dispatch) => ({});

export default withRouter(
	connect(mapStateToProps, mapDispatchToProps)(BuyerNewWorkOrderProposalPage)
);
